import React from "react";

const readAlertPostObject = (key: string): Record<string, unknown> => {
  if (typeof localStorage === "undefined" || !localStorage[key]) {
    return {};
  }

  try {
    return JSON.parse(localStorage[key]);
  } catch {
    return {};
  }
};

export const checkInitialDataForImmixOrSentinelValues = (initialData: any) => {
  const immixAlertPostObject = readAlertPostObject("immixAlertPostObject");
  const diceAlertPostObject = readAlertPostObject("diceAlertPostObject");
  const sentinelAlertPostObject = readAlertPostObject("sentinelAlertPostObject");

  const updatedInitialData = initialData;

  if (immixAlertPostObject.immix_server) {
    updatedInitialData.immix_server = immixAlertPostObject.immix_server;
  }

  if (immixAlertPostObject.immix_port) {
    updatedInitialData.immix_port = immixAlertPostObject.immix_port;
  }

  if (diceAlertPostObject.dice_server) {
    updatedInitialData.dice_server = diceAlertPostObject.dice_server;
  }

  if (diceAlertPostObject.dice_port) {
    updatedInitialData.dice_port = diceAlertPostObject.dice_port;
  }

  if (sentinelAlertPostObject.sentinel_server) {
    updatedInitialData.sentinel_server =
      sentinelAlertPostObject.sentinel_server;
  }

  if (sentinelAlertPostObject.sentinel_site_id) {
    updatedInitialData.sentinel_site_id =
      sentinelAlertPostObject.sentinel_site_id;
  }

  if (sentinelAlertPostObject.sentinel_device_address) {
    updatedInitialData.sentinel_device_address =
      sentinelAlertPostObject.sentinel_device_address;
  }

  if (sentinelAlertPostObject.draw_ignore_zones) {
    updatedInitialData.draw_ignore_zones = sentinelAlertPostObject.draw_ignore;
  }

  return updatedInitialData;
};
